<ng-container *ngIf="dialogType === 'delete_checklist'">
  <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title text-center">Delete Template</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p>{{dialogHeader}}</p>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button class="button-normal flex-1" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="button-normal flex-1 m-0" color="error"
        [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="dialogType === 'save_new_checklist' || dialogType === 'replace_checklist'">
  <div class="countable-dialog mh-100 h-100 tepmlate-selection-right-drawer right-drawer-dialog" style="width: 350px;">
    <div mat-dialog-title class="dialog-header p-2">
      <h4 class="title">Select a checklist</h4>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content tempaltes-list p-0 h-100 overflow-hidden">
      <div class="template-block-main">
        <mat-tab-group (selectedIndexChange)="onChangeTabSections($event)">
          <mat-tab>
            <ng-template mat-tab-label>
              Firm templates
            </ng-template>
            <ng-template matTabContent>
              <div class="search-block gap-20">
                <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatlabel="always">
                  <mat-label>Search</mat-label>
                  <input matInput placeholder="Search" [formControl]="searchChecklist" maxlength="25">
                  <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  </span>
                </mat-form-field>
              </div>

              <div class="templates-list">
                <ng-container *ngIf="templatesData$ | async">
                  <ng-container *ngFor="let folder of templatesData$ | async">
                    <mat-accordion #accordion="matAccordion" multi="true">
                      <mat-expansion-panel [expanded]="folder.isexpand == 'true'">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div class="title-content"
                              title="{{folder.foldername}} ({{folder.checklisttemplates ? folder.checklisttemplates .length : 0}} checklists)">
                              <span class="togglable-icon">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                              </span>
                              <span class="item-icon">
                                <i class="fa-regular fa-folder-bookmark"></i>
                              </span>
                              <span class="item-title">{{folder.foldername}} ({{folder.checklisttemplates ?
                                folder.checklisttemplates .length : 0}} checklists)</span>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="folder.checklisttemplates">
                          <mat-list role="list" class="templates-list-items">
                            <mat-list-item class="listitem"
                              *ngFor="let template of folder.checklisttemplates; trackBy: trackByFirmTemplate"
                              [ngStyle]="{'background-color': template.ishighlight === 'true' ? '#D8ECFE' : ''}">
                              <div class="list-item-content" [ngClass]="{'disabled': (template.is_copied_to_engagement === 1 || template?.isDisabled),
                                'template-locked': !billing.hasReview && template.engagementtypeid === 2 }"
                                (click)="(!billing.hasReview && template?.engagementtypeid === 2) ? upgradePlanDialog() : saveSelection(template)"
                                title="{{template.ChecklistTemplateName}}">

                                <span class="item-icon">
                                  <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                                </span>
                                <p class="item-title">{{template.ChecklistTemplateName}}</p>
                                <span class="lock-icon" *ngIf="!billing.hasReview && template.engagementtypeid === 2">
                                  <i class="fa-regular fa-lock-keyhole"></i>
                                </span>
                              </div>
                            </mat-list-item>
                          </mat-list>
                        </ng-container>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </ng-container>
                </ng-container>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab *ngIf="false" disabled>
            <ng-template mat-tab-label>
              Master library
            </ng-template>
            <ng-container *ngIf="masterTemplatesData$ | async">
              <ng-container *ngFor="let folder of masterTemplatesData$ | async">
                <mat-accordion #accordion="matAccordion" multi="true">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="title-content" title="{{folder.StandardName}}">
                          <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                          </span>
                          <span class="item-icon">
                            <i class="fa-regular fa-folder-bookmark"></i>
                          </span>
                          <span class="item-title">{{folder.StandardName}}</span>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="folder.child">
                      <mat-list role="list" class="templates-list-items">
                        <mat-list-item class="listitem"
                          *ngFor="let template of folder.child; trackBy: trackByFirmTemplate">
                          <div class="list-item-content" (click)="saveSelection(template)" [mat-dialog-close]="true"
                            title="{{template.submodulename}}">
                            <span class="item-icon">
                              <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                            </span>
                            <p class="item-title">{{template.submodulename}}</p>
                          </div>
                        </mat-list-item>
                      </mat-list>
                    </ng-container>
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-container>
            </ng-container>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>

    <!-- <div mat-dialog-actions class="dialog-footer button-group">
          <button mat-button mat-stroked-button color="dark" class="button-medium" [mat-dialog-close]="false">No</button>
           <button mat-button mat-flat-button color="primary" class="button-medium" [mat-dialog-close]="true">Yes</button>
         </div> -->
  </div>
</ng-container>


<ng-container *ngIf="dialogType === 'move_leftsidedoc'">
  <div class="countable-dialog moveDialog w-100" style="max-width: 400px;">
    <div mat-dialog-title class="dialog-header">
      <h4 class="title">
        <button mat-button class="button-text" title="Back" (click)="$event.stopPropagation();goToHome()">
          <i class="fa-regular fa-arrow-left"></i>
        </button>
        Move To
      </h4>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content template-block-main overflow-hidden py-3 px-0">
      <div class="button-group justify-content-start px-20">
        <button mat-button mat-stroked-button color="primary" class="btn-medium-icon" title="Collapse All"
          (click)="isMoveExpandAll = false" *ngIf="isMoveExpandAll">
          <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
        </button>
        <button mat-button mat-stroked-button color="primary" class="btn-medium-icon" title="Expand All"
          (click)="isMoveExpandAll = true" *ngIf="!isMoveExpandAll">
          <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
        </button>
      </div>

      <div class="templates-list overflow-auto">
        <mat-accordion multi="true">
          <!-- Client Onboarding *ngIf="folderData$ | async as folderList" (section.subModuleUUID === '2f23ac84-00d' || section.subModuleUUID ==='4941162c-20f' || section.subModuleUUID === '2f25bbd4-00d')-->
          <ng-container *ngFor="let folder of templatesData; let i=index;trackBy: trackByMoveFolders">
            <ng-container>
              <mat-expansion-panel [expanded]="isMoveExpandAll">
                <mat-expansion-panel-header>
                  <!-- <ng-container *ngIf="folder.sectionData"> -->
                  <mat-panel-title title="{{folder.folderName ? folder.folderName : folder.name}}">
                    <div class="title-content">
                      <span class="item-checkbox" *ngIf="!folder.sectionData && !folder.child"
                        [ngClass]="{'disabled': restrictModuleIds.includes(folder.subModuleUUID)}">
                        <mat-radio-button (change)="selectedMoveChoice(folder)"
                          [disabled]="restrictModuleIds.includes(folder.subModuleUUID)"
                          class="custom-checkbox"></mat-radio-button>
                      </span>
                      <span class="togglable-icon" *ngIf="folder.sectionData || folder.child">
                        <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                      </span>
                      <span class="item-icon" *ngIf="folder.sectionData || folder.child">
                        <i class="fa-regular fa-folder-bookmark"></i>
                      </span>
                      <span class="item-title">{{folder.folderName ? folder.folderName : folder.name}}</span>
                    </div>
                  </mat-panel-title>

                </mat-expansion-panel-header>

                <ng-container *ngIf="folder.sectionData || (folder.child && folder.subModuleUUID === '2f210188-00d')">
                  <ng-container *ngFor="let section of folder.sectionData;">
                    <ng-container *ngIf="folder.subModuleUUID !== '2f210188-00d'">
                      <mat-expansion-panel class="level-one">
                        <mat-expansion-panel-header>
                          <mat-panel-title title="{{section.sectionName}}">
                            <div class="title-content"
                              [ngClass]="{'disabled': restrictModuleIds.includes(section.subModuleUUID)}">
                              <span class="item-checkbox">
                                <mat-radio-button (change)="selectedMoveChoice(section)" class="custom-checkbox"
                                  [disabled]="restrictModuleIds.includes(section.subModuleUUID)"></mat-radio-button>
                              </span>
                              <span class="togglable-icon" *ngIf="section.sectionData || section.child">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                              </span>
                              <span class="item-icon">
                                <i class="fa-regular fa-folder-bookmark"></i>
                              </span>
                              <span class="item-title">{{section.sectionName}}</span>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                      </mat-expansion-panel>
                    </ng-container>
                  </ng-container>


                  <ng-container *ngIf="folder.subModuleUUID === '2f210188-00d'">
                    <ng-container *ngFor="let child of folder.child; let i=index;">
                      <mat-expansion-panel class="level-two" [expanded]="isMoveExpandAll">
                        <mat-expansion-panel-header>
                          <mat-panel-title title="{{child.fingroupname}}">
                            <div class="title-content">
                              <span class="togglable-icon">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                              </span>
                              <span class="item-icon">
                                <i class="fa-regular fa-folder-bookmark"></i>
                              </span>
                              <span class="item-title">{{child.fingroupname}}</span>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>


                        <ng-container *ngFor="let finsubgroupNameData of child.finsubgroup">
                          <mat-expansion-panel class="level-tree" [expanded]="isMoveExpandAll">
                            <mat-expansion-panel-header>
                              <mat-panel-title title="{{finsubgroupNameData.finsubgroupname}}">
                                <div class="title-content">
                                  <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                  </span>
                                  <span class="item-icon">
                                    <i class="fa-regular fa-folder-bookmark"></i>
                                  </span>
                                  <span class="item-title">{{finsubgroupNameData.finsubgroupname}}</span>
                                </div>
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-list role="list" class="templates-list-items">
                              <mat-list-item *ngFor="let leadsheetData of finsubgroupNameData.leadsheet"
                                title="{{leadsheetData.leadsheetname}}">
                                <div class="list-item-content"
                                  [ngClass]="{'disabled': restrictModuleIds.includes(leadsheetData.subModuleUUID)}">
                                  <mat-radio-button (change)="selectedMoveChoice(leadsheetData)"
                                    [disabled]="restrictModuleIds.includes(leadsheetData.subModuleUUID)"></mat-radio-button>
                                  <span class="item-title">{{leadsheetData.leadsheetname}}</span>
                                </div>
                              </mat-list-item>
                            </mat-list>
                          </mat-expansion-panel>
                        </ng-container>
                      </mat-expansion-panel>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </mat-expansion-panel>
            </ng-container>
          </ng-container>

          <!-- Procedures -->
        </mat-accordion>
      </div>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button color="dark" class="button-medium"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button color="primary" class="button-medium" [mat-dialog-close]="true"
        (click)="moveDocument()" [disabled]="!selectedToMoveObj">Move</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(dialogType === 'upgrade_plan') && (aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-circle-exclamation"></i>
      </span>
    </div>
    @if(dialogData === 'Upgrade_Free_Trial'){
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <h4 class="title">{{dialogHeader}}</h4>
      <p class="title"> Your Free Trial plan has limited Flex Engagements </p>
      <p class="title"> Upgrade now to create additional Flex Engagements</p>
    </div>
    }@else{
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <h4 class="title">Update your plan</h4>
      <!-- <p class="title mb-2">You are currently on the Essentials Plan </p> -->
      <p class="title"> To unlock the review documents, please </p>
      <p class="title"> upgrade to Accelerate plan</p>
    </div>
    }

    <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button color="dark" class="button-medium"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button color="primary" class="button-medium"
        [mat-dialog-close]="true">Upgrade</button>
    </div>
  </div>
</ng-container>

<!-- Account Paused -->
<ng-container *ngIf="dialogType === 'account_paused'">
  <div class="countable-dialog account-paused-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center">
        <span class="badge badge-circle badge-error icon-bordered-error">
            <i class="fa-regular fa-circle-info"></i>
        </span>
        <!-- <button mat-button class="close" [mat-dialog-close]="false">
            <i class="fa-regular fa-xmark clear-icon"></i>
        </button> -->
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
      <h4 class="title text-center me-2">Account Paused
      </h4>
      <p>
        Your Account has been <b>Paused.</b>
      </p>
      <p *ngIf="!(aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
        Please contact your Super Admin <br>to re-activate the account.
      </p>
    </div>
    <div mat-dialog-actions class="dialog-footer flex-column mt-3" (click)="$event.stopPropagation()">
      <div class="button-group">
        <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="true">Okay
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- Trial Expired -->
<ng-container *ngIf="dialogType === 'trial_expired'">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
      <span class="badge badge-circle badge-error">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <h4 class="title text-center me-2">Free Trial Expired!
      </h4>
      <p>
        Your free trial has expired!
      </p>
      <p *ngIf="!(aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
        Please contact your Super Admin to upgrade <br> and regain access to the platform
      </p>
    </div>
    <div mat-dialog-actions class="dialog-footer flex-column mt-3" (click)="$event.stopPropagation()">
      <div class="button-group">
        <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="true">Ok
        </button>
      </div>
    </div>
  </div>
</ng-container>


<!-- Storage Limit Reached! -->
<ng-container *ngIf="(dialogType === 'storage_limit') && (aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-circle-info"></i>
      </span>
    </div>
    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title text-center">
        Storage Limit Reached!
      </h4>
      <p class="">You have reached the storage limit on your {{dialogData}}</p>
      <p>To continue using the platform, please clear storage, or upgrade your plan.</p>

    </div>
    <div mat-dialog-actions class="w-100 dialog-footer button-group " (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button class="flex-1 button-medium" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="flex-1 button-medium" color="primary"
        [mat-dialog-close]="true">Upgrade</button>
    </div>
  </div>
</ng-container>

<!-- generic popup for review eng , storage limit reached and eng count reached (Only who don't have access to billing page) -->
<ng-container
  *ngIf="(dialogType === 'storage_limit' || dialogType === 'upgrade_plan' || dialogType === 'eng_limit') && !(aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
    <div class="content dialog-body-content text-center gap-8" *ngIf="dialogType === 'upgrade_plan'">
      <h4 class="title text-center">
        Upgrade your plan
      </h4>
      <p class="">To unlock the review documents or add more documents,
        please reach out to Super admin for upgrading the plan.</p>

    </div>
    <div class="content dialog-body-content text-center gap-8" *ngIf="dialogType === 'eng_limit'">
      <h4 class="title text-center">
        Engagement Limit Reached
      </h4>
      <p class="">You have reached the maximum engagement creation limit on your <b>{{dialogData}}</b></p>
      <p class="fw-medium text-error">Note: To continue using the platform, please delete engagements, or upgrade your
        plan.</p>

    </div>
    <div class="content dialog-body-content text-center gap-8" *ngIf="dialogType === 'storage_limit'">
      <h4 class="title text-center">
        Storage Limit Reached
      </h4>
      <p class="">You have reached the storage limit on your {{dialogData}}.
        To Continue adding more documents please clear the storage or reach out to Super admin to upgrade your plan.</p>

    </div>
  </div>
</ng-container>

<!-- Maximum Engagment limit reached! -->
<ng-container *ngIf="(dialogType === 'eng_limit') && (aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-circle-info"></i>
      </span>
    </div>
    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title text-center">
        Engagement Limit Reached
      </h4>
      <p class="">You have reached the maximum engagement creation limit on your <b>{{dialogData}}</b></p>
      <p class="fw-medium text-error">Note: To continue using the platform, please delete engagements, or upgrade your
        plan.</p>

    </div>
    <div mat-dialog-actions class="w-100 dialog-footer button-group " (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button class="flex-1 button-medium" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="flex-1 button-medium" color="primary"
        [mat-dialog-close]="true">Upgrade</button>
    </div>
  </div>
</ng-container>

<!--Add team member-->
<ng-container *ngIf="(dialogType === 'addTeamBillingInfo')">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header  d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error ">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
      <h4 class="title text-center">Add New User</h4>
      <p class="fw-medium">As you've introduced a new user, your account will incur a pro-rated charge for this
        additional user for the current month </p>
      <p>Do you wish to proceed?</p>
    </div>
    <div mat-dialog-actions class="dialog-footer flex-column" (click)="$event.stopPropagation()">
      <ng-container>
        <div class="button-group">
          <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]="false">Cancel
          </button>
          <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="true">Confirm
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<!-- peg/pact subscription expires in 1 month and 3 days -->
<ng-container *ngIf="(dialogType === 'pegPactExpiresInMonthOrDays')">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div mat-dialog-title class="dialog-header  d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error ">
        <i class="fa-regular fa-circle-info"></i>
      </span>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
      <h4 class="title text-center me-2 px-3">{{dialogData}}
      </h4>
      <p class="text-error fw-bold px-3">
        You will lose access to Master Library under templates if the subscription is not renewed.
      </p>
      <p class="fw-bold text-gray-6 px-3" *ngIf="aclModel && aclModel.hasFirmInformationEdit">Please ensure you update
        the most recent information for invoice and expiry
        under ‘settings'.
      </p>
      <p class="fw-bold text-gray-6 px-3" *ngIf="aclModel && aclModel.hasFirmInformationEdit">please click on Update
        license button to update the PEG/PACT details.
      </p>

      <p class="fw-bold text-gray-6 px-3" *ngIf="!(aclModel && aclModel.hasFirmInformationEdit)">Please contact your
        super admin for more information.
      </p>

    </div>
    <div mat-dialog-actions class="dialog-footer flex-column mt-3" (click)="$event.stopPropagation()"
      *ngIf="aclModel && aclModel.hasFirmInformationEdit">
      <div class="button-group">
        <button routerLink="/dashboard/members/settings/myaccount" mat-button mat-flat-button class="button-medium"
          color="primary" [mat-dialog-close]="false">Update License
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!--Your account is scheduled to delete or pause-->
<ng-container *ngIf="(dialogType === 'scheduledToDeleteOrPause')">
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 350px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-primary badge-circle icon-bordered-primary" matBadgeColor="primary">
        <i class="fa-regular fa-circle-check text-success"></i>
      </span>
      <h4 class="title" *ngIf="data?.mainHeader">{{data?.mainHeader}}</h4>
      <button color="error" class="close" [mat-dialog-close]="true">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p class="title">{{dialogHeader}}</p>
      <p class="fw-bold mt-2">i.e. {{dialogData}} </p>
    </div>
    <div class="mat-dialog-actions dialog-footer button-group">
      <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="true">Okay
      </button>
    </div>
  </div>
</ng-container>

<!-- Management Letter Add Letter -->

<ng-container *ngIf="dialogType === 'add_letter'">
  <ng-container *ngIf="templatesData$ | async as letterTemplates">
    <div class="countable-dialog right-drawer mh-100">
      <div mat-dialog-title class="dialog-header px-3">
        <h4 class="title">Select letter template</h4>
        <button mat-button class="close" [mat-dialog-close]="false">
          <i class="fa-regular fa-xmark clear-icon"></i>
        </button>
      </div>

      <div mat-dialog-content class="dialog-body-content template-block-main p-0 pt-3">
        <div class="template-block-main">
          <mat-tab-group (selectedIndexChange)="onChangeTabSections($event)" [(selectedIndex)]="letterTabIndex">
            <mat-tab>
              <ng-template mat-tab-label>
                Firm templates
              </ng-template>
              <ng-template matTabContent>
                <div class="search-block gap-20">
                  <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatlabel="always">
                    <mat-label>Search</mat-label>
                    <input matInput placeholder="Search" [formControl]="searchContent" maxlength="25">
                    <span matPrefix>
                      <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                    </span>
                  </mat-form-field>
                </div>

                <ng-container *ngIf="letterTemplates?.folderdata && letterTemplates?.folderdata.length > 0">
                  <mat-accordion class="templates-list" #accordion="matAccordion" multi="true">
                    <ng-container *ngFor="let folder of letterTemplates?.folderdata;">
                      <mat-expansion-panel [expanded]="folder.isexpand == 'true'">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div class="title-content"
                              title="{{folder.foldername}} ({{folder.templates ? folder.templates.length : 0}} letters)">
                              <span class="togglable-icon">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                              </span>
                              <span class="item-icon">
                                <i class="fa-regular fa-folder-bookmark"></i>
                              </span>
                              <p class="item-title" style="max-width: 250px;">{{folder.foldername}}</p>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <ng-container *ngIf="folder.templates">
                          <mat-list role="list" class="templates-list-items">
                            <mat-list-item role="listitem"
                              *ngFor="let template of folder.templates; trackBy: trackByFirmTemplate"
                              title="{{template.TemplateName}}">
                              <ng-container>
                                <span class="list-item-content"
                                  [ngStyle]="{'background-color': template.ishighlight === 'true' ? '#D8ECFE' : ''}"
                                   [ngClass]="{'disabled': template?.isDisabled || aclModel?.isSupport }"
                                  (click)="setManagementLetter(template,'firm')" [mat-dialog-close]="true">
                                  <span class="item-icon">
                                    <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                                  </span>
                                  <span class="item-title">{{template.TemplateName}}</span>
                                  <span class="set-default-dot" *ngIf="template.is_default === 1"></span>
                                </span>
                              </ng-container>
                            </mat-list-item>
                          </mat-list>
                        </ng-container>
                      </mat-expansion-panel>
                    </ng-container>
                  </mat-accordion>
                </ng-container>

              </ng-template>
            </mat-tab>


            <mat-tab [disabled]="!isPegPactExpired()">
              <ng-template mat-tab-label>
                <span>Master library</span>
              </ng-template>
              <ng-template matTabContent>
                <div class="search-block gap-20">
                  <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatlabel="always">
                    <mat-label>Search</mat-label>
                    <input matInput placeholder="Search" [formControl]="searchContent" maxlength="25">
                    <span matPrefix>
                      <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                    </span>
                  </mat-form-field>
                </div>
                <ng-container *ngIf="letterTemplates?.mastertemplate && letterTemplates?.mastertemplate.length > 0">
                  <mat-accordion class="templates-list" #accordion="matAccordion" multi="true">
                    <ng-container *ngFor="let folder of letterTemplates?.mastertemplate">
                      <mat-expansion-panel [expanded]="folder.isexpand == 'true'">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div class="title-content" title="{{folder.StandardName}}">
                              <span class="togglable-icon">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                              </span>
                              <span class="item-icon">
                                <i class="fa-regular fa-folder-bookmark"></i>
                              </span>
                              <p class="item-title" style="max-width: 250px;">{{folder.StandardName}}</p>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="folder.template">
                          <mat-list role="list" class="templates-list-items">
                            <mat-list-item role="listitem" *ngFor="let template of folder.template;" title="{{template?.templatename}}"
                            [ngClass]="{'disabled': template?.isDisabled || aclModel?.isSupport}"
                            [ngStyle]="{'background-color': template.ishighlight === 'true' ? '#D8ECFE' : ''}">
                              <ng-container>
                                <span class="list-item-content" (click)="setManagementLetter(template,'master')"
                                  [mat-dialog-close]="true">
                                  <span class="item-icon">
                                    <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                                  </span>
                                  <span class="item-title">{{template?.templatename}}</span>
                                  <span class="set-default-dot" *ngIf="template?.is_default === 1">
                                  </span>
                                </span>
                              </ng-container>
                            </mat-list-item>
                          </mat-list>
                        </ng-container>
                      </mat-expansion-panel>
                    </ng-container>
                  </mat-accordion>
                </ng-container>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>


<ng-container *ngIf="dialogType === 'plaid_deactivated'">
<div class="countable-dialog w-100" style="max-width: 400px;" (click)="$event.stopPropagation()">
  <div mat-dialog-title class="dialog-header  d-flex flex-column align-items-center p-0">
    <span class="badge badge-error badge-circle icon-bordered-error text-center">
      <i class="fa-regular fa-circle-exclamation"></i>
    </span>
    <h4 class="title text-center px-3">Plaid Access Removed</h4>
    <p>The Super Admin has deactivated Plaid access</p>
    <button mat-button class="close" [mat-dialog-close]="true" (click)="takeAcknoledgement()">
      <i class="material-icons clear-icon">close</i>
    </button>
  </div>
  <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">

    <p class="text-error">Note: Please save all your data and complete the work as needed. Access will be taken away
      tonight at 12:00AM
    </p>
    <p>
      For any queries, please contact your super admin at</p>
    <div class="plaid-remove-user d-flex align-items-center justify-content-center gap-8">
      <div class="plaid-remove-icon">
        <ngx-avatars initialsSize="2" size="30" [bgColor]="getColorFromName(plaidData?.fullName)" [name]="plaidData?.fullName"></ngx-avatars>
      </div>
      <div class="plaid-remove-detail d-flex flex-column align-items-start gap-4">
        {{plaidData.fullName}}
        <span class="text-gray-7">{{plaidData?.email}}</span>
      </div>

    </div>


  </div>

  <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="true" (click)="takeAcknoledgement()">OK
      </button>
  </div>
</div>
</ng-container>
<!-- Delete single account popup -->
@if (dialogType === 'delete_account') {
<div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
  <div mat-dialog-title class="dialog-header gap-8 align-items-center p-4 pb-3">
    <span class="badge badge-error badge-circle icon-bordered-error text-center">
      <i class="fa-regular fa-trash-can"></i>
    </span>
    <h4 class="title text-center">{{dialogHeader}}</h4>
    @if (!isConfirmationPopup()) {
      <p class="text-center">{{dialogContent().paraOne}} </p>
    }
  </div>
  @if (!isConfirmationPopup()) {
  <div mat-dialog-content class="content dialog-body-content gap-22">
    <p class="fw-medium">{{dialogContent().paraTwo}}</p>
    <ul class="list-items-none flexbox-column gap-16 card p-3 delete-issue">
      <li class="flexbox-row gap-8 flex-wrap flex-md-nowrap justify-content-between align-items start">
        <div class="d-flex gap-8 align-items-center">
          <i class="fa-regular fa-circle-xmark text-error fs-20"></i>
          <h5 class="text-start">Issues</h5>
        </div>
        <h5>{{dialogData.issuesCount}}</h5>
      </li>
      <li class="flexbox-row gap-8 flex-wrap flex-md-nowrap justify-content-between align-items start">
        <div class="d-flex gap-8 align-items-center">
          <i class="fa-regular fa-circle-xmark text-error fs-20"></i>
          <h5 class="text-start">Comments</h5>
        </div>
        <h5>{{dialogData.commentsCount}}</h5>
      </li>
      <li class="flexbox-row gap-8 flex-wrap flex-md-nowrap justify-content-between align-items start">
        <div class="d-flex gap-8 align-items-center">
          <i class="fa-regular fa-circle-xmark text-error fs-20"></i>
          <h5 class="text-start">Notes</h5>
        </div>
        <h5>{{dialogData.notesCount}}</h5>
      </li>
      <li class="flexbox-row gap-8 flex-wrap flex-md-nowrap justify-content-between align-items start">
        <div class="d-flex gap-8 align-items-center">
          <i class="fa-regular fa-circle-xmark text-error fs-20"></i>
          <h5 class="text-start">Request</h5>
        </div>
        <h5>{{dialogData.requestsCount}}</h5>
      </li>
    </ul>
    <p class="fw-semibold text-gray-7">{{deleteDialogText.CONFIRMATION_LINE}}</p>

  </div>
  }@else if (isConfirmationPopup()) {
  <div mat-dialog-content class="content dialog-body-content gap-24">
    <p class="fw-medium px-4">{{dialogContent().confirmText}}</p>
    <mat-form-field class="fixed-label w-100" floatLabel="always">
      <input class="bg-white shadow-none" matInput [(ngModel)]="confirmationText" [placeholder]=dialogData.placeholder
        maxlength="20">
    </mat-form-field>
  </div>
  }
  <div mat-dialog-actions class="dialog-footer">
    @if (!isConfirmationPopup()) {
    <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]="false">Cancel
    </button>
    <button mat-button mat-flat-button class="button-medium" color="error" (click)="showConfirmationDialog()">Delete
    </button>
    }@else if (isConfirmationPopup()) {
    <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]="false">No
    </button>
    <button mat-button mat-flat-button class="button-medium" color="error" [disabled]="confirmationText != dialogData.placeholder"
    (click)="deleteConfirmation()" [mat-dialog-close]="true">Confirm</button>
    }
  </div>
</div>
}
